//@ts-check
import request from '../request';
/**
 * Get job info
 * @param {string} workspace
 * @param {string} jobId
 * @return {Promise<import("./types").Job>}
 */

export var getJob = function getJob(workspace, jobId) {
  return request({
    url: "/backend/jobs/".concat(jobId),
    query: {
      workspace: workspace
    }
  });
};
/**
 * Run a job from a workflow
 * @param {string} workspace
 * @param {string} workflowPath
 * @return {Promise<import("./types").Job>}
 */

export var runJob = function runJob(workspace, workflowPath) {
  // jobs endpoint expects the path to be with back-slashed, otherwise there are no resulting files
  workflowPath = workflowPath.split('/').join('\\');
  return request({
    url: '/backend/jobs',
    method: 'POST',
    data: {
      Workspace: workspace,
      WorkflowPath: workflowPath
    }
  });
};
/**
 * Rename a specified job
 * @param {string} workspace
 * @param {string} jobId
 * @param {string} name
 * @return {Promise<import("./types").Job>}
 */

export var renameJob = function renameJob(workspace, jobId, name) {
  return request({
    url: "/backend/jobs?id=".concat(jobId),
    method: 'PUT',
    data: {
      Workspace: workspace,
      Name: name,
      Type: 'rename'
    }
  });
};
/**
 * Rename a specified job
 * @param {string} workspace
 * @param {string} jobId
 * @return {Promise}
 */

export var deleteJob = function deleteJob(workspace, jobId) {
  return request({
    url: "/backend/jobs?id=".concat(jobId, "&workspace=").concat(encodeURIComponent(workspace)),
    method: 'DELETE'
  });
};
export default {
  getJob: getJob,
  runJob: runJob,
  renameJob: renameJob,
  deleteJob: deleteJob
};